import React from 'lib/react';
import { useDispatch, useSelector } from 'lib/redux';
import { ORDER_HISTORY_FILTERS_UPDATE_DATE_RANGE } from 'constants/ActionTypes';
import { DATE_RANGES } from '../../commonComponents/dateRangeFilter/DateFilter.utils';
import DateRangeFilter from '../../commonComponents/dateRangeFilter/DateRangeFilter.component';

function DateFilter() {
  const dispatch = useDispatch();
  const {
    startDate, endDate, dateError, selectedDateOption,
  } = useSelector(({ orderHistory }) => orderHistory.orderHistoryFilters);

  const handleDateChange = (event) => {
    const { target: { id, value } } = event;
    dispatch({
      type: ORDER_HISTORY_FILTERS_UPDATE_DATE_RANGE,
      [id]: value,
      selectedDateOption: DATE_RANGES.CUSTOM,
    });
  };

  const handleDateRangeOptionChange = (dateValues, optionValue) => {
    dispatch({
      type: ORDER_HISTORY_FILTERS_UPDATE_DATE_RANGE,
      startDate: dateValues[0],
      endDate: dateValues[1],
      selectedDateOption: optionValue,
    });
  };
  return (
    <DateRangeFilter
      startDate={startDate}
      endDate={endDate}
      dateError={dateError}
      selectedDateOption={selectedDateOption}
      handleDateChange={handleDateChange}
      handleDateRangeOptionChange={handleDateRangeOptionChange}
    />
  );
}

export default DateFilter;
